












import { Vue, Prop, Component, Watch } from "vue-property-decorator";
@Component({})
export default class Page extends Vue {
  @Prop({
    required: true
  })
  value;

  my_input = false;
  @Watch("value", { immediate: true })
  onChange(newValue) {
    this.my_input = newValue;
  }

  onCheck() {
    this.$emit("input", this.my_input);
  }
  toAgreement() {
    // this.$router.push({ path: '/logistics-track', query: { orderNo: row.row.orderNo }})

    const routeData = this.$router.resolve({ path: '/privacy/agreement'})
    window.open(routeData.href, '_blank')
  }
}
